import { createBrowserRouter, createHashRouter } from "react-router-dom";
import { Layout } from "../layout";
import {
  HomePage,
  MachinePage,
  MachineUserPage,
  MyStorePage,
  RevenueMachinePage,
  RevenueMachineUserPage,
  RevenueStorePage,
  RevenueStoreUserPage,
  RolePage,
  SignInPage,
  StatisticalPage,
  StorePage,
  UserCreatePage,
  UserPage,
  TransactionManagePage,
} from "../pages";
import path from "../ultils/path";
import ResultPage from "../pages/tracking/ResultPage";
import TypeTransactionPage from "../pages/tracking/TypeTransactionPage";
import SolutionPage from "../pages/tracking/SolutionPage";
import DetailErrorPage from "../pages/detail-error/DetailErrorPage";
import VoucherManagePage from "../pages/voucher/VoucherManagePage";
import MachineOfStoreManage from "../pages/machine/MachineOfStoreManage";
import FrameManagePage from "../pages/frame-manage/FrameManagePage";
import FrameAnalysticPage from "../pages/frame/FrameAnalysticPage";
import AccountManage from "../pages/account/AccountManage";
import VerifyNewAccount from "../pages/verify-new-account/VerifyNewAccount";
import RenvenueCalendar from "../pages/revenue/RenvenueCalendar";

const routers = createHashRouter([
  {
    path: "/",
    element: <Layout></Layout>,
    children: [
      { path: path.HOME, element: <HomePage /> },
      { path: path.SIGN_IN, element: <SignInPage /> },
      { path: path.ROLE_MANAGER, element: <RolePage /> },
      { path: path.ACOOUNT_MANAGER, element: <AccountManage /> },
      // user
      { path: path.USER_MANAGER, element: <UserPage /> },
      { path: path.USER_CREATE, element: <UserCreatePage /> },
      { path: path.STATISTICAL_MANAGE, element: <StatisticalPage /> },
      // store
      { path: path.STORE_MANAGE, element: <StorePage /> },
      { path: path.MY_STORE, element: <MyStorePage /> },
      // machine
      { path: path.MACHINE_MANAGE, element: <MachinePage /> },
      { path: path.MACHINE_USER_MANAGE, element: <MachineUserPage /> },
      { path: path.MACHINE_OF_STORE, element: <MachineOfStoreManage /> },
      // revenue
      { path: path.REVENUE_STORE, element: <RevenueStorePage /> },
      { path: path.REVENUE_MACHINE_OVERALL, element: <RenvenueCalendar /> },
      { path: path.REVENUE_STORE_USER, element: <RevenueStoreUserPage /> },
      { path: path.REVENUE_MACHINE, element: <RevenueMachinePage /> },
      { path: path.REVENUE_MACHINE_USER, element: <RevenueMachineUserPage /> },
      // tracking
      { path: path.RESULT, element: <ResultPage /> },
      { path: path.TYPE_TRANSACTION, element: <TypeTransactionPage /> },
      { path: path.SOLUTION, element: <SolutionPage /> },
      { path: path.DETAIL_ERROR, element: <DetailErrorPage /> },
      // voucher
      { path: path.VOUCHER_MANAGE, element: <VoucherManagePage /> },
      // transaction
      { path: path.TRANSACTION_MANAGE, element: <TransactionManagePage /> },
      // frame
      { path: path.FRAME_MANAGE, element: <FrameManagePage /> },
      { path: path.FRAME_ANALYSTIC, element: <FrameAnalysticPage /> },
      // verify new account
      { path: path.VERIFY_NEW_ACCOUNT, element: <VerifyNewAccount /> },
    ],
  },
]);

export default routers;
